/**
 * rb-byob-mobile-coll-match-v1 / rb-byob-desk-3col-stars-v1 — one mark per card.
 */
(function () {
  var ROOT = '#gbbBundle';
  var MARK = 'rb-byob-card-mark';

  function isMobile() {
    return window.innerWidth <= 999;
  }

  function isKratom(text) {
    var t = String(text || '').toLowerCase();
    return t.indexOf('kratom') !== -1 || t.indexOf('kava') !== -1;
  }

  function cardTitle(item) {
    var el =
      item.querySelector('.gbbProductTitleOnly') ||
      item.querySelector('.gbbProductTitle') ||
      item.querySelector('.gbbProductItemTitle');
    return el ? el.textContent : '';
  }

  function hostFor(item) {
    return (
      item.querySelector('.gbbProductImageContainer') ||
      item.querySelector('[class*="ProductImageContainer"]') ||
      item
    );
  }

  function ensureMobileCollectionMark(item, kratom) {
    var host = hostFor(item);
    if (!host) return;

    var old = item.querySelector('.' + MARK);
    if (old) old.remove();

    var wrap = item.querySelector('.rb-product__img-brand');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'rb-product__img-brand';
      wrap.setAttribute('aria-hidden', 'true');
      host.appendChild(wrap);
    }
    if (wrap.parentNode !== host) host.appendChild(wrap);
    wrap.classList.toggle('rb-product__img-brand--kratom', kratom);

    var mark = wrap.querySelector('.rb-product__brand-logo-mark');
    if (!mark) {
      mark = document.createElement('span');
      mark.className = 'rb-product__brand-logo-mark';
      mark.setAttribute('role', 'img');
      wrap.appendChild(mark);
    }
    mark.classList.toggle('rb-product__brand-logo-mark--canna', !kratom);
    mark.classList.toggle('rb-product__brand-logo-mark--kratom', kratom);
    mark.setAttribute('aria-label', kratom ? 'Kratom River' : 'Canna River');
    host.style.setProperty('position', 'relative', 'important');
  }

  function ensureDesktopMark(item, kratom) {
    var host = hostFor(item);
    if (!host) return;
    var brand = kratom ? 'kratom' : 'canna';
    var existing = item.querySelector('.' + MARK);
    if (existing) {
      existing.classList.toggle(MARK + '--kratom', kratom);
      existing.classList.toggle(MARK + '--canna', !kratom);
      if (existing.parentNode !== host) host.appendChild(existing);
      return;
    }
    var mark = document.createElement('span');
    mark.className = MARK + ' ' + MARK + '--' + brand;
    mark.setAttribute('role', 'img');
    mark.setAttribute('aria-label', kratom ? 'Kratom River' : 'Canna River');
    host.appendChild(mark);
  }

  function pruneExtras(item, mobile) {
    var brands = item.querySelectorAll('.rb-product__img-brand');
    var byobs = item.querySelectorAll('.' + MARK);
    if (mobile) {
      byobs.forEach(function (el) {
        el.remove();
      });
      brands.forEach(function (el, i) {
        if (i > 0) el.remove();
      });
      if (brands[0]) {
        brands[0].querySelectorAll('.rb-product__brand-logo-mark').forEach(function (el, i) {
          if (i > 0) el.remove();
        });
      }
    } else {
      brands.forEach(function (el) {
        el.remove();
      });
      byobs.forEach(function (el, i) {
        if (i > 0) el.remove();
      });
    }
  }

  function ensureMark(item) {
    if (!item || item.nodeType !== 1) return;
    var kratom = isKratom(cardTitle(item));
    var mobile = isMobile();
    pruneExtras(item, mobile);
    if (mobile) ensureMobileCollectionMark(item, kratom);
    else ensureDesktopMark(item, kratom);
  }

  function sync() {
    var root = document.querySelector(ROOT);
    if (!root) return;
    root.querySelectorAll('.gbbProductItem').forEach(ensureMark);
  }

  var timer;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 80);
  }

  sync();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync, { once: true });
  }
  window.addEventListener('load', sync, { once: true });

  var prevReady = window.rbByobMarkReady;
  window.rbByobMarkReady = function () {
    if (typeof prevReady === 'function') prevReady();
    sync();
  };

  if (window.MutationObserver) {
    var mo = new MutationObserver(schedule);
    function observe() {
      var root = document.querySelector(ROOT);
      if (!root) return false;
      mo.observe(root, { childList: true, subtree: true });
      return true;
    }
    if (!observe()) {
      var boot = new MutationObserver(function () {
        if (observe()) boot.disconnect();
      });
      boot.observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  var n = 0;
  var keep = window.setInterval(function () {
    sync();
    n += 1;
    if (n > 30) window.clearInterval(keep);
  }, 500);
})();
